import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { Observable, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

import { DocumentsActions, DocumentsSelectors, PackageDocument } from 'src/app/features/documents';
import { RootStoreState } from 'src/app/store';
import { MatSelectChange } from '@angular/material/select';
import { EndorsementRemainingModalComponent } from '../endorsement-remaining-modal';
import { EndorsementsSelectors } from '../../../endorsements';

@Component({
    selector: 'app-signing-room-document-selector',
    templateUrl: './document-selector.component.html',
    styleUrls: ['./document-selector.component.scss'],
    standalone: false
})
export class DocumentSelectorComponent implements OnInit, OnDestroy {
  packageDocuments$: Observable<Array<PackageDocument>>;
  currentPackageDocument: PackageDocument;
  selectedPackageDocument: PackageDocument;
  areEndorsementRemaining: boolean;
  notifier = new Subject();

  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.packageDocuments$ = this.store.pipe(select(DocumentsSelectors.selectPackageDocuments));
    this.store
      .pipe(
        select(DocumentsSelectors.selectActivePackageDocument),
        takeUntil(this.notifier),
        filter((packageDocument) => !!packageDocument),
        tap((packageDocument) => {
          this.selectedPackageDocument = packageDocument;
          this.currentPackageDocument = packageDocument;
        })
      )
      .subscribe();

    this.store
      .pipe(
        takeUntil(this.notifier),
        select(EndorsementsSelectors.selectActiveDocumentRemainingRequiredActions),
        tap((count) => (this.areEndorsementRemaining = count !== 0))
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.notifier.next(undefined);
    this.notifier.complete();
  }

  onDocumentSelect(event: MatSelectChange) {
    if (this.areEndorsementRemaining) {
      this.openEndorsementRemainingModal(this.selectedPackageDocument.packageDocumentId);
    } else {
      this.moveToDocument(this.selectedPackageDocument.packageDocumentId);
    }
  }

  openEndorsementRemainingModal(documentId: number) {
    EndorsementRemainingModalComponent.openModal(
      this.store,
      this.moveToDocument.bind(this, documentId),
      this.stayOnDocument.bind(this)
    );
  }

  moveToDocument(documentId: number) {
    this.store.dispatch(DocumentsActions.NavigateToDocument({ payload: documentId }));
  }

  stayOnDocument() {
    this.selectedPackageDocument = this.currentPackageDocument;
  }
}
